export default {
    claims: [],
    eligibilityOptions: [],
    shippingLabel: {},
    warranties: [],
    claimDetails: [],
    showOrderUpdateAlert: false,
    reconcileUsers: [],
    reconcileShippinglabel:{}
};
